import { render, staticRenderFns } from "./ValanceDisclaimer.vue?vue&type=template&id=5cb64b9a&scoped=true&"
import script from "./ValanceDisclaimer.vue?vue&type=script&lang=ts&"
export * from "./ValanceDisclaimer.vue?vue&type=script&lang=ts&"
import style0 from "./ValanceDisclaimer.vue?vue&type=style&index=0&id=5cb64b9a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb64b9a",
  null
  
)

export default component.exports